<template src="./Notification.html"></template>
<style lang="scss" scoped src="./Notification.scss"></style>

<script>
import {SfIcon, SfNotification} from '@storefront-ui/vue';

export default {
  name: 'Notification',
  components: {
    SfNotification,
    SfIcon
  },
  computed: {
    notifications: {
      get() {
        return this.$store.getters.getNotifications;
      }
    }
  }
}
</script>



